export const translations = {
  en: {
    // Header
    'header.call': 'Call Us',
    'header.email': 'Email Us',
    'header.home': 'Home',
    'header.about': 'About Us',
    'header.practices': 'Practice Areas',
    'header.contact': 'Contact',
    'header.consultation': 'Consultation',
    'header.tools': 'Tools',
    'header.blog': 'Blog',
    
    // Practice Areas
    'practices.immigration': 'Immigration Services',
    'practices.criminal': 'Criminal Defense',
    'practices.injury': 'Personal Injury',
    'practices.family': 'Family Law',
    'practices.tax': 'Tax Law',
    'practices.probate': 'Probate & Estate Planning',
    'practices.realestate': 'Real Estate Law',
    'practices.business': 'Business Law',
    
    // Common CTAs
    'cta.schedule': 'Schedule Consultation',
    'cta.contact': 'Contact Us Today',
    'cta.learn': 'Learn More',
    'cta.call.en': 'Call English',
    'cta.call.es': 'Call Spanish',
    'cta.call.vi': 'Call Vietnamese',
    
    // Emergency (removed as per requirements)
    'emergency.title': 'Need Immediate Legal Assistance?',
    'emergency.desc': 'Contact us during business hours or schedule a consultation:',
    
    // Footer
    'footer.about': 'About',
    'footer.services': 'Services',
    'footer.resources': 'Resources',
    'footer.legal': 'Privacy Policy',
    'footer.terms': 'Terms of Use',
    'footer.rights': 'All rights reserved',
    'footer.disclaimer': 'The information on this website is for general information purposes only. Nothing on this site should be taken as legal advice for any individual case or situation.',
    'footer.quicklinks': 'Quick Links',
    'footer.contact': 'Contact Us',
    'footer.description': 'Leading immigration lawyer in Houston specializing in asylum, naturalization, visas, deportation defense. Also providing criminal defense, personal injury, family law & more.',
    'footer.areas': 'Areas We Serve',
    'footer.areas.serving': 'Immigration Attorney Serving:',
    
    // Practice Area Descriptions
    'practices.immigration.desc': 'Comprehensive immigration legal services',
    'practices.criminal.desc': 'Expert criminal defense representation',
    'practices.injury.desc': 'Fighting for your injury claim',
    'practices.family.desc': 'Compassionate family law guidance',
    'practices.tax.desc': 'Tax litigation and resolution',
    'practices.probate.desc': 'Protecting your legacy',
    'practices.realestate.desc': 'Real estate transactions and disputes',
    'practices.business.desc': 'Business formation and protection',
    
    // About Page
    'about.title': 'About Daniel Albert Law Firm',
    'about.subtitle': 'Committed to providing exceptional legal representation with integrity, dedication, and expertise.',
    'about.story': 'Our Story',
    'about.story.p1': 'Daniel Albert Law Firm was founded with a clear mission: to provide accessible, high-quality legal services to individuals and families in Houston and throughout Texas.',
    'about.story.p2': 'With years of experience across multiple practice areas, our team understands the challenges our clients face. Whether you\'re navigating complex immigration processes, defending against criminal charges, seeking compensation for injuries, or dealing with family law matters, we\'re here to guide you every step of the way.',
    'about.story.p3': 'Our trilingual approach ensures that language is never a barrier to justice. We serve clients in English, Spanish, and Vietnamese, making sure everyone has access to the legal representation they deserve.',
    'about.values': 'Our Values',
    'about.values.subtitle': 'The principles that guide our practice and commitment to our clients',
    'about.values.excellence': 'Excellence',
    'about.values.excellence.desc': 'We strive for excellence in every case, delivering the highest quality legal representation.',
    'about.values.client': 'Client-Focused',
    'about.values.client.desc': 'Your needs come first. We provide personalized attention and clear communication throughout your case.',
    'about.values.access': 'Accessibility',
    'about.values.access.desc': 'Trilingual services in English, Spanish, and Vietnamese, making legal help accessible to all communities.',
    'about.values.integrity': 'Integrity',
    'about.values.integrity.desc': 'We uphold the highest ethical standards and are committed to honest, transparent representation.',
    'about.commitment': 'Our Commitment to You',
    'about.commitment.personal': 'Personalized Service',
    'about.commitment.personal.desc': 'Every case is unique, and we treat it that way. We take the time to understand your situation, goals, and concerns to develop a strategy tailored to your needs.',
    'about.commitment.communication': 'Clear Communication',
    'about.commitment.communication.desc': 'Legal matters can be complex, but we believe in explaining everything in clear, understandable terms. You\'ll always know where your case stands.',
    'about.commitment.representation': 'Aggressive Representation',
    'about.commitment.representation.desc': 'When you need a strong advocate, we\'re ready to fight. We pursue every legal avenue to protect your rights and achieve the best possible outcome.',
    'about.commitment.available': 'Dedicated Availability',
    'about.commitment.available.desc': 'We understand urgent legal matters require prompt attention. Contact us during business hours for immediate assistance and scheduling.',
    'about.credentials': 'Credentials & Memberships',
    'about.credentials.licensed': 'Licensed Attorney',
    'about.credentials.bar': 'State Bar of Texas',
    'about.credentials.aila': 'AILA Member',
    'about.credentials.aila.full': 'American Immigration Lawyers Association',
    'about.credentials.track': 'Proven Track Record',
    'about.credentials.cases': 'Hundreds of successful cases',
    
    // Contact Page
    'contact.title': 'Contact Us',
    'contact.subtitle': 'Get in touch with Daniel Albert Law Firm. We\'re here to help with your legal needs.',
    'contact.getintouch': 'Get In Touch',
    'contact.office': 'Office Location',
    'contact.phone': 'Phone Numbers',
    'contact.email': 'Email',
    'contact.hours': 'Office Hours',
    'contact.hours.mon': 'Monday–Friday: 9:00 AM – 6:00 PM',
    'contact.hours.closed': 'Closed Saturday & Sunday',
    
    // Consultation Page
    'consult.title': 'Consultation',
    'consult.subtitle': 'Schedule your consultation with Daniel Albert Law Firm. Let\'s discuss your case and find the best path forward.',
    'consult.expect': 'What to Expect',
    'consult.expect.desc': 'Your consultation is an opportunity to learn about your legal options without any commitment. We\'ll take the time to understand your situation and provide honest guidance.',
    'consult.during': 'During Your Consultation:',
    'consult.benefit1': 'Discuss your case with an experienced attorney',
    'consult.benefit2': 'Understand your legal options and potential outcomes',
    'consult.benefit3': 'Get honest, straightforward advice about your situation',
    'consult.benefit4': 'Learn about our process and how we can help',
    'consult.benefit5': 'No obligation consultation',
    'consult.benefit6': 'Trilingual services available in English, Spanish, and Vietnamese',
    'consult.note': 'Important Note',
    'consult.note.desc': 'During the consultation, please be prepared to discuss the key facts of your case. The more information you provide, the better we can assess your situation and provide helpful guidance. All consultations are confidential.',
    
    // Blog Page
    'blog.title': 'Legal Blog',
    'blog.subtitle': 'Expert legal insights, updates, and guidance from Daniel Albert Law Firm',
    'blog.all': 'All',
    'blog.read': 'Read More',
    'blog.subscribe': 'Stay Updated',
    'blog.subscribe.desc': 'Subscribe to our newsletter for the latest legal updates, immigration news, and helpful resources.',
    'blog.email': 'Your email address',
    'blog.subscribe.btn': 'Subscribe',
    
    // Homepage
    'home.hero.title': 'Top Immigration Lawyer in Houston, Texas',
    'home.hero.subtitle': 'Expert immigration services including asylum, naturalization, visas, deportation defense. Also providing Criminal Defense, Personal Injury, Family Law & more. Trilingual services (English/Spanish/Vietnamese).',
    'home.hero.consultation': 'Book Consultation',
    'home.hero.call': 'Call',
    'home.areas.title': 'Our Practice Areas',
    'home.areas.subtitle': 'Comprehensive legal services across multiple areas of law',
    'home.areas.viewall': 'View All Practice Areas',
    'home.why.title': 'Why Choose Daniel Albert Law Firm?',
    'home.why.subtitle': 'Dedicated legal representation with a proven track record',
    'home.why.team': 'Experienced Legal Team',
    'home.why.team.desc': 'Years of successful representation across multiple practice areas in Houston and beyond.',
    'home.why.bilingual': 'Trilingual Services',
    'home.why.bilingual.desc': 'Fluent in English, Spanish, and Vietnamese, ensuring clear communication throughout your case.',
    'home.why.available': 'Responsive Service',
    'home.why.available.desc': 'Prompt response to your legal needs during business hours with flexible scheduling options.',
    'home.why.results': 'Proven Results',
    'home.why.results.desc': 'Track record of successful outcomes in complex and challenging cases.',
    'home.process.title': 'Our Process',
    'home.process.subtitle': 'A simple, effective approach to your legal matters',
    'home.process.step1': 'Consultation',
    'home.process.step1.desc': 'Discuss your case with our experienced attorneys.',
    'home.process.step2': 'Case Strategy',
    'home.process.step2.desc': 'We develop a customized legal strategy tailored to your situation.',
    'home.process.step3': 'Representation',
    'home.process.step3.desc': 'We handle all filings, communications, and court appearances.',
    'home.process.step4': 'Resolution',
    'home.process.step4.desc': 'We fight for the best possible outcome in your case.',
    'home.testimonials.title': 'Client Testimonials',
    'home.testimonials.subtitle': 'See what our clients say about our services',
    
    // Testimonials Section
    'testimonials.title': 'Trusted by Families and Businesses Across Houston',
    'testimonials.subtitle': 'Hear what our clients say about their experience with Daniel Albert Law Firm',
    'testimonials.viewMore': 'View All Reviews',
    
    // Video Testimonials Section
    'home.videoTestimonials.title': 'Client Video Testimonials',
    'home.videoTestimonials.subtitle': 'Real stories from real clients - hear directly from those we\'ve helped',
    
    // Chatbot
    'chatbot.title': 'Legal Assistant',
    'chatbot.subtitle': 'Ask me about our services',
    'chatbot.placeholder': 'Type your question...',
    'chatbot.schedule': 'Schedule Free Consultation',
    'home.cta.ready': 'Ready to Discuss Your Case?',
    'home.cta.ready.desc': 'Contact Daniel Albert Law Firm today for a consultation. Our experienced attorneys are ready to fight for your rights.',
    
    // Practice Areas Page
    'pa.title': 'Our Practice Areas',
    'pa.subtitle': 'Comprehensive legal services across multiple areas of law. Whatever your legal needs, we\'re here to help.',
    'pa.why.title': 'Why Choose Daniel Albert Law Firm?',
    'pa.why.subtitle': 'No matter what legal challenge you\'re facing, our experienced team is ready to provide the representation you deserve.',
    'pa.why.expertise': 'Multi-Practice Expertise',
    'pa.why.expertise.desc': 'Eight practice areas under one roof means comprehensive legal support for all your needs.',
    'pa.why.trilingual': 'Trilingual Services',
    'pa.why.trilingual.desc': 'Full legal services in English, Spanish, and Vietnamese, ensuring clear communication.',
    'pa.why.response': 'Prompt Service',
    'pa.why.response.desc': 'Quick response during business hours with flexible consultation scheduling to meet your needs.',
    'pa.cta.title': 'Not Sure Which Service You Need?',
    'pa.cta.desc': 'Contact us for a consultation. We\'ll discuss your situation and guide you to the right legal solution.',
    'pa.keyservices': 'Key Services:',
    
    // CTA Section
    'cta.ready': 'Ready to Get Started?',
    'cta.ready.desc': 'Contact us today for a consultation. We\'re here to help you navigate your legal challenges.',
    'cta.emergency.title': 'Need Legal Assistance?',
    'cta.emergency.desc': 'Contact us during business hours for prompt attention to your legal matter.',
    'cta.callnow': 'Call Now',
    'cta.english': 'English',
    'cta.spanish': 'Español',
    'cta.vietnamese': 'Tiếng Việt',
    'cta.disclaimer': 'Consultation is free when you retain our services by receiving a $150 credit toward your legal fees.',
    'cta.consultation.button': 'Book Consultation',
    
    // Consultation Form
    'form.title': 'Request a Consultation',
    'form.gcal.button': 'Schedule on Google Calendar',
    'form.gcal.note': 'Availability may vary from our internal system',
    'form.gcal.opens': 'Opens in a new window',
    'consult.calendar.desc': 'Book your consultation appointment directly through Google Calendar for immediate confirmation.',
    'form.name': 'Full Name',
    'form.email': 'Email',
    'form.phone': 'Phone Number',
    'form.area': 'Practice Area',
    'form.message': 'Message',
    'form.message.placeholder': 'Please describe your legal matter...',
    'form.message.desc': 'Brief description of your legal matter (10-1000 characters)',
    'form.caseExplanation': 'Explain your case',
    'form.caseExplanation.placeholder': 'Provide details about your legal situation...',
    'form.questions': 'What questions do you have for attorney?',
    'form.questions.placeholder': 'Write your questions here...',
    'form.consent': 'I agree to the terms and conditions',
    'form.consent.desc': 'By submitting this form, you agree that Daniel Albert Law Firm may contact you regarding your inquiry. This does not create an attorney-client relationship.',
    'form.submit': 'Submit Consultation Request',
    'form.submitting': 'Submitting...',
    'form.note': 'Note: Submitting this form does not create an attorney-client relationship. Do not include confidential or time-sensitive information in this form.',
    'form.success': 'Consultation request submitted successfully!',
    'form.success.desc': 'We\'ll contact you within 24 hours.',
    'form.error': 'Failed to submit consultation request',
    'form.error.desc': 'Please try again or call us directly.',
    'form.select.placeholder': 'Select a practice area',
    
    // Consultation Additional Fields
    'consult.urgency': 'How urgent is your case?',
    'consult.urgency.placeholder': 'Select urgency level',
    'consult.urgency.immediate': 'Immediate (Within 24 hours)',
    'consult.urgency.week': 'This Week',
    'consult.urgency.month': 'This Month',
    'consult.urgency.flexible': 'Flexible',
    'consult.language': 'Preferred Language for Consultation',
    'consult.language.placeholder': 'Select preferred language',
    'consult.appointment.title': 'Schedule Your Appointment',
    'consult.appointment.desc': 'Choose your preferred appointment type and date',
    'consult.preferredDate': 'Preferred Date',
    'consult.selectDate': 'Pick a date',
    'consult.dateNote': 'We will confirm the exact time with you after reviewing your request',
    
    // Booking form
    'booking.title': 'Schedule Your Consultation',
    'booking.subtitle': 'Book your consultation appointment directly through Google Calendar for immediate confirmation',
    'booking.step': 'Step',
    'booking.of': 'of',
    'booking.next': 'Next',
    'booking.previous': 'Previous',
    'booking.submit': 'Submit Booking',
    'booking.selectService': 'Select Service Type',
    'booking.selectServiceDescription': 'Choose the legal service you need consultation for',
    'booking.immigration': 'Immigration',
    'booking.criminalDefense': 'Criminal Defense',
    'booking.personalInjury': 'Personal Injury',
    'booking.familyLaw': 'Family Law',
    'booking.tax': 'Tax',
    'booking.probateEstate': 'Probate & Estate Planning',
    'booking.realEstate': 'Real Estate',
    'booking.businessLaw': 'Business Law',
    'booking.fullName': 'Full Name',
    'booking.dateOfBirth': 'Date of Birth',
    'booking.email': 'Email',
    'booking.phone': 'Phone Number',
    'booking.address': 'Address',
    'booking.employerTitle': 'Employer & Job Title',
    'booking.situation': 'Explain your situation in detail',
    'booking.situationPlaceholder': 'Please describe your legal situation (minimum 30 characters)',
    'booking.appointmentType': 'Appointment Type',
    'booking.inPerson': 'In-person',
    'booking.phoneCall': 'Phone',
    'booking.video': 'Video',
    'booking.chooseDateTime': 'Choose Date & Time',
    'booking.viewAvailability': 'View Available Times',
    'booking.calendarDesc': 'Check our availability calendar below to see open time slots. After payment confirmation, we will schedule your appointment based on mutual availability.',
    'booking.calendarNote': 'Dates shown are in Central Time (Houston, TX). Your exact appointment time will be confirmed after payment.',
    'booking.preferredDate': 'Preferred Appointment Date',
    'booking.preferredTime': 'Preferred Time',
    'booking.referredBy': 'How did you hear about us?',
    'booking.search': 'Search Engine',
    'booking.googleAds': 'Google Ads',
    'booking.facebook': 'Facebook',
    'booking.instagram': 'Instagram',
    'booking.blog': 'Blog',
    'booking.other': 'Other',
    'booking.referredOther': 'Please specify',
    'booking.consentNotifications': 'I agree to receive email notifications for this appointment',
    'booking.consentTerms': 'I understand this consultation is non-refundable and does not create an attorney-client relationship',
    'booking.required': 'This field is required',
    'booking.minLength': 'Minimum {count} characters required',
    'booking.invalidEmail': 'Invalid email address',
    'booking.invalidPhone': 'Invalid phone number',
    'booking.yes': 'Yes',
    'booking.no': 'No',
    'booking.paymentTitle': 'Payment Method',
    'booking.paymentDescription': 'Choose how you would like to pay for your consultation ($150 USD)',
    'booking.stripe': 'Credit/Debit Card (Stripe)',
    'booking.zelle': 'Zelle',
    'booking.checkWire': 'Check/Wire Transfer',
    'booking.zelleInstructions': 'Zelle Instructions',
    'booking.zelleEmail': 'Send payment to: payment@danielalbertlaw.com',
    'booking.zelleConfirmation': 'Zelle Confirmation Number',
    'booking.zelleConfirmationPlaceholder': 'Enter your confirmation number',
    'booking.checkWireInstructions': 'Check/Wire Transfer Instructions',
    'booking.checkWireDetails': 'Please contact our office at (832) 538-0833 for payment details.',
    'booking.paymentEvidence': 'Upload Payment Evidence (Optional)',
    'booking.paymentEvidenceDescription': 'You can upload a screenshot or photo of your payment confirmation',
    
    // Booking Success Page
    'bookingSuccess.title': 'Payment Successful!',
    'bookingSuccess.subtitle': 'Your consultation has been booked and confirmed',
    'bookingSuccess.bookingNumber': 'Booking Number',
    'bookingSuccess.whatsNext': "What's Next?",
    'bookingSuccess.step1': 'Email Confirmation',
    'bookingSuccess.step1Desc': 'You will receive a confirmation email with your appointment details within minutes.',
    'bookingSuccess.step2': 'Prepare Your Documents',
    'bookingSuccess.step2Desc': 'Please bring all relevant documents to your consultation.',
    'bookingSuccess.step3': 'Arrive On Time',
    'bookingSuccess.step3Desc': 'Please arrive 10 minutes before your scheduled appointment.',
    'bookingSuccess.reminder': 'Important Reminder',
    'bookingSuccess.reminderText': 'This consultation is non-refundable. The consultation does not create an attorney-client relationship until a representation agreement is signed.',
    'bookingSuccess.officeLocation': 'Office Location:',
    'bookingSuccess.contact': 'Contact:',
    'bookingSuccess.returnHome': 'Return Home',
    'bookingSuccess.addToCalendar': 'Add to Calendar',
  },
  es: {
    // Header
    'header.call': 'Llámenos',
    'header.email': 'Envíe Email',
    'header.home': 'Inicio',
    'header.about': 'Nosotros',
    'header.practices': 'Áreas de Práctica',
    'header.contact': 'Contacto',
    'header.consultation': 'Consulta',
    'header.tools': 'Herramientas',
    'header.blog': 'Blog',
    
    // Practice Areas
    'practices.immigration': 'Servicios de Inmigración',
    'practices.criminal': 'Defensa Criminal',
    'practices.injury': 'Lesiones Personales',
    'practices.family': 'Derecho de Familia',
    'practices.tax': 'Derecho Fiscal',
    'practices.probate': 'Sucesiones y Planificación',
    'practices.realestate': 'Bienes Raíces',
    'practices.business': 'Derecho Empresarial',
    
    // Common CTAs
    'cta.schedule': 'Agende Consulta',
    'cta.contact': 'Contáctenos Hoy',
    'cta.learn': 'Más Información',
    'cta.call.en': 'Llamar Inglés',
    'cta.call.es': 'Llamar Español',
    'cta.call.vi': 'Llamar Vietnamita',
    
    // Emergency (removed as per requirements)
    'emergency.title': '¿Necesita Asistencia Legal Inmediata?',
    'emergency.desc': 'Contáctenos durante el horario de oficina o programe una consulta:',
    
    // Footer
    'footer.about': 'Acerca de',
    'footer.services': 'Servicios',
    'footer.resources': 'Recursos',
    'footer.legal': 'Política de Privacidad',
    'footer.terms': 'Términos de Uso',
    'footer.rights': 'Todos los derechos reservados',
    'footer.disclaimer': 'La información en este sitio web es solo para fines informativos generales. Nada en este sitio debe tomarse como asesoramiento legal para ningún caso o situación individual.',
    'footer.quicklinks': 'Enlaces Rápidos',
    'footer.contact': 'Contáctenos',
    'footer.description': 'Representación legal experta en inmigración, defensa criminal, lesiones personales y más. Sirviendo a Houston con dedicación e integridad.',
    'footer.areas': 'Áreas que Servimos',
    'footer.areas.serving': 'Abogado de Inmigración Sirviendo:',
    
    // Practice Area Descriptions
    'practices.immigration.desc': 'Servicios legales de inmigración integrales',
    'practices.criminal.desc': 'Representación experta en defensa criminal',
    'practices.injury.desc': 'Luchando por su reclamo de lesiones',
    'practices.family.desc': 'Orientación compasiva en derecho familiar',
    'practices.tax.desc': 'Litigios y resolución fiscal',
    'practices.probate.desc': 'Protegiendo su legado',
    'practices.realestate.desc': 'Transacciones y disputas inmobiliarias',
    'practices.business.desc': 'Formación y protección empresarial',
    
    // About Page
    'about.title': 'Acerca del Bufete Daniel Albert',
    'about.subtitle': 'Comprometidos a brindar representación legal excepcional con integridad, dedicación y experiencia.',
    'about.story': 'Nuestra Historia',
    'about.story.p1': 'El Bufete Daniel Albert fue fundado con una misión clara: proporcionar servicios legales accesibles y de alta calidad a individuos y familias en Houston y en todo Texas.',
    'about.story.p2': 'Con años de experiencia en múltiples áreas de práctica, nuestro equipo comprende los desafíos que enfrentan nuestros clientes. Ya sea que esté navegando por procesos complejos de inmigración, defendiéndose de cargos criminales, buscando compensación por lesiones o tratando asuntos de derecho familiar, estamos aquí para guiarlo en cada paso.',
    'about.story.p3': 'Nuestro enfoque trilingüe garantiza que el idioma nunca sea una barrera para la justicia. Servimos a clientes en inglés, español y vietnamita, asegurándonos de que todos tengan acceso a la representación legal que merecen.',
    'about.values': 'Nuestros Valores',
    'about.values.subtitle': 'Los principios que guían nuestra práctica y compromiso con nuestros clientes',
    'about.values.excellence': 'Excelencia',
    'about.values.excellence.desc': 'Nos esforzamos por la excelencia en cada caso, brindando la representación legal de más alta calidad.',
    'about.values.client': 'Enfocados en el Cliente',
    'about.values.client.desc': 'Sus necesidades son lo primero. Proporcionamos atención personalizada y comunicación clara durante todo su caso.',
    'about.values.access': 'Accesibilidad',
    'about.values.access.desc': 'Servicios trilingües en inglés, español y vietnamita, haciendo que la ayuda legal sea accesible para todas las comunidades.',
    'about.values.integrity': 'Integridad',
    'about.values.integrity.desc': 'Mantenemos los más altos estándares éticos y estamos comprometidos con una representación honesta y transparente.',
    'about.commitment': 'Nuestro Compromiso con Usted',
    'about.commitment.personal': 'Servicio Personalizado',
    'about.commitment.personal.desc': 'Cada caso es único y lo tratamos de esa manera. Nos tomamos el tiempo para comprender su situación, objetivos e inquietudes para desarrollar una estrategia adaptada a sus necesidades.',
    'about.commitment.communication': 'Comunicación Clara',
    'about.commitment.communication.desc': 'Los asuntos legales pueden ser complejos, pero creemos en explicar todo en términos claros y comprensibles. Siempre sabrá el estado de su caso.',
    'about.commitment.representation': 'Representación Agresiva',
    'about.commitment.representation.desc': 'Cuando necesita un defensor fuerte, estamos listos para luchar. Perseguimos todas las vías legales para proteger sus derechos y lograr el mejor resultado posible.',
    'about.commitment.available': 'Disponibilidad Dedicada',
    'about.commitment.available.desc': 'Comprendemos que los asuntos legales urgentes requieren atención inmediata. Contáctenos durante el horario de oficina para asistencia inmediata.',
    'about.credentials': 'Credenciales y Membresías',
    'about.credentials.licensed': 'Abogado Licenciado',
    'about.credentials.bar': 'Colegio de Abogados de Texas',
    'about.credentials.aila': 'Miembro de AILA',
    'about.credentials.aila.full': 'Asociación Americana de Abogados de Inmigración',
    'about.credentials.track': 'Historial Comprobado',
    'about.credentials.cases': 'Cientos de casos exitosos',
    
    // Contact Page
    'contact.title': 'Contacto',
    'contact.subtitle': 'Póngase en contacto con el Bufete Daniel Albert. Estamos aquí para ayudar con sus necesidades legales.',
    'contact.getintouch': 'Contáctenos',
    'contact.office': 'Ubicación de la Oficina',
    'contact.phone': 'Números de Teléfono',
    'contact.email': 'Correo Electrónico',
    'contact.hours': 'Horario de oficina',
    'contact.hours.mon': 'Lunes a Viernes: 9:00 AM – 6:00 PM',
    'contact.hours.closed': 'Cerrado Sábado y Domingo',
    
    // Consultation Page
    'consult.title': 'Consulta',
    'consult.subtitle': 'Programe su consulta con el Bufete Daniel Albert. Hablemos de su caso y encontremos el mejor camino a seguir.',
    'consult.expect': 'Qué Esperar',
    'consult.expect.desc': 'Su consulta es una oportunidad para conocer sus opciones legales sin ningún compromiso. Nos tomaremos el tiempo para entender su situación y brindarle orientación honesta.',
    'consult.during': 'Durante Su Consulta:',
    'consult.benefit1': 'Discuta su caso con un abogado experimentado',
    'consult.benefit2': 'Comprenda sus opciones legales y resultados potenciales',
    'consult.benefit3': 'Obtenga consejos honestos y directos sobre su situación',
    'consult.benefit4': 'Conozca nuestro proceso y cómo podemos ayudar',
    'consult.benefit5': 'Consulta sin obligación',
    'consult.benefit6': 'Servicios trilingües disponibles en inglés, español y vietnamita',
    'consult.note': 'Nota Importante',
    'consult.note.desc': 'Durante la consulta, prepárese para discutir los hechos clave de su caso. Cuanta más información proporcione, mejor podremos evaluar su situación y brindar orientación útil. Todas las consultas son confidenciales.',
    
    // Blog Page
    'blog.title': 'Blog Legal',
    'blog.subtitle': 'Perspectivas legales expertas, actualizaciones y orientación del Bufete Daniel Albert',
    'blog.all': 'Todos',
    'blog.read': 'Leer Más',
    'blog.subscribe': 'Manténgase Actualizado',
    'blog.subscribe.desc': 'Suscríbase a nuestro boletín para recibir las últimas actualizaciones legales, noticias de inmigración y recursos útiles.',
    'blog.email': 'Su dirección de correo electrónico',
    'blog.subscribe.btn': 'Suscribirse',
    
    // Homepage
    'home.hero.title': 'Mejor Abogado de Inmigración en Houston, Texas',
    'home.hero.subtitle': 'Servicios expertos de inmigración incluyendo asilo, naturalización, visas, defensa contra deportación. También brindamos Defensa Criminal, Lesiones Personales, Derecho Familiar y más. Servicios trilingües (inglés/español/vietnamita).',
    'home.hero.consultation': 'Agendar Consulta',
    'home.hero.call': 'Llamar',
    'home.areas.title': 'Nuestras Áreas de Práctica',
    'home.areas.subtitle': 'Servicios legales integrales en múltiples áreas del derecho',
    'home.areas.viewall': 'Ver Todas las Áreas de Práctica',
    'home.why.title': '¿Por Qué Elegir el Bufete Daniel Albert?',
    'home.why.subtitle': 'Representación legal dedicada con un historial comprobado',
    'home.why.team': 'Equipo Legal Experimentado',
    'home.why.team.desc': 'Años de representación exitosa en múltiples áreas de práctica en Houston y más allá.',
    'home.why.bilingual': 'Servicios Trilingües',
    'home.why.bilingual.desc': 'Fluido en inglés, español y vietnamita, asegurando una comunicación clara durante todo su caso.',
    'home.why.available': 'Servicio Receptivo',
    'home.why.available.desc': 'Respuesta rápida a sus necesidades legales durante el horario de oficina con opciones de programación flexibles.',
    'home.why.results': 'Resultados Comprobados',
    'home.why.results.desc': 'Historial de resultados exitosos en casos complejos y desafiantes.',
    'home.process.title': 'Nuestro Proceso',
    'home.process.subtitle': 'Un enfoque simple y efectivo para sus asuntos legales',
    'home.process.step1': 'Consulta',
    'home.process.step1.desc': 'Discuta su caso con nuestros abogados experimentados.',
    'home.process.step2': 'Estrategia del Caso',
    'home.process.step2.desc': 'Desarrollamos una estrategia legal personalizada adaptada a su situación.',
    'home.process.step3': 'Representación',
    'home.process.step3.desc': 'Manejamos todas las presentaciones, comunicaciones y comparecencias ante el tribunal.',
    'home.process.step4': 'Resolución',
    'home.process.step4.desc': 'Luchamos por el mejor resultado posible en su caso.',
    'home.testimonials.title': 'Testimonios de Clientes',
    'home.testimonials.subtitle': 'Vea lo que nuestros clientes dicen sobre nuestros servicios',
    
    // Testimonials Section
    'testimonials.title': 'Confianza de Familias y Negocios en Todo Houston',
    'testimonials.subtitle': 'Escuche lo que nuestros clientes dicen sobre su experiencia con el Bufete Daniel Albert',
    'testimonials.viewMore': 'Ver Todas las Reseñas',
    
    // Video Testimonials Section
    'home.videoTestimonials.title': 'Testimonios en Video de Clientes',
    'home.videoTestimonials.subtitle': 'Historias reales de clientes reales - escuche directamente de aquellos a quienes hemos ayudado',
    
    // Chatbot
    'chatbot.title': 'Asistente Legal',
    'chatbot.subtitle': 'Pregúntame sobre nuestros servicios',
    'chatbot.placeholder': 'Escribe tu pregunta...',
    'chatbot.schedule': 'Agendar Consulta',
    'home.cta.ready': '¿Listo para Discutir Su Caso?',
    'home.cta.ready.desc': 'Contacte al Bufete Daniel Albert hoy para una consulta. Nuestros abogados experimentados están listos para luchar por sus derechos.',
    
    // Practice Areas Page
    'pa.title': 'Nuestras Áreas de Práctica',
    'pa.subtitle': 'Servicios legales integrales en múltiples áreas del derecho. Cualesquiera que sean sus necesidades legales, estamos aquí para ayudar.',
    'pa.why.title': '¿Por Qué Elegir el Bufete Daniel Albert?',
    'pa.why.subtitle': 'No importa qué desafío legal esté enfrentando, nuestro equipo experimentado está listo para brindarle la representación que merece.',
    'pa.why.expertise': 'Experiencia Multipráctica',
    'pa.why.expertise.desc': 'Ocho áreas de práctica bajo un mismo techo significa apoyo legal integral para todas sus necesidades.',
    'pa.why.trilingual': 'Servicios Trilingües',
    'pa.why.trilingual.desc': 'Servicios legales completos en inglés, español y vietnamita, asegurando una comunicación clara.',
    'pa.why.response': 'Servicio Rápido',
    'pa.why.response.desc': 'Respuesta rápida durante el horario de oficina con programación de consultas flexibles para satisfacer sus necesidades.',
    'pa.cta.title': '¿No Está Seguro Qué Servicio Necesita?',
    'pa.cta.desc': 'Contáctenos para una consulta. Discutiremos su situación y lo guiaremos a la solución legal correcta.',
    'pa.keyservices': 'Servicios Clave:',
    
    // CTA Section
    'cta.ready': '¿Listo para Comenzar?',
    'cta.ready.desc': 'Contáctenos hoy para una consulta. Estamos aquí para ayudarlo a navegar sus desafíos legales.',
    'cta.emergency.title': '¿Necesita Asistencia Legal?',
    'cta.emergency.desc': 'Contáctenos durante el horario de oficina para atención inmediata a su asunto legal.',
    'cta.callnow': 'Llamar Ahora',
    'cta.english': 'Inglés',
    'cta.spanish': 'Español',
    'cta.vietnamese': 'Vietnamita',
    'cta.disclaimer': 'La consulta es gratuita al contratar nuestros servicios, recibiendo un crédito de $150 aplicado a tus honorarios legales.',
    'cta.consultation.button': 'Agendar consulta',
    
    // Consultation Form
    'form.title': 'Solicite una Consulta',
    'form.gcal.button': 'Agendar en Google Calendar',
    'form.gcal.note': 'La disponibilidad puede variar respecto a la agenda del sitio',
    'form.gcal.opens': 'Se abre en una ventana nueva',
    'consult.calendar.desc': 'Reserve su cita de consulta directamente a través de Google Calendar para confirmación inmediata.',
    'form.name': 'Nombre Completo',
    'form.email': 'Correo Electrónico',
    'form.phone': 'Número de Teléfono',
    'form.area': 'Área de Práctica',
    'form.message': 'Mensaje',
    'form.message.placeholder': 'Por favor describa su asunto legal...',
    'form.message.desc': 'Breve descripción de su asunto legal (10-1000 caracteres)',
    'form.caseExplanation': 'Explique su caso',
    'form.caseExplanation.placeholder': 'Proporcione detalles sobre su situación legal...',
    'form.questions': '¿Qué preguntas tiene para el abogado?',
    'form.questions.placeholder': 'Escriba sus preguntas aquí...',
    'form.consent': 'Acepto los términos y condiciones',
    'form.consent.desc': 'Al enviar este formulario, acepta que el Bufete Daniel Albert puede contactarlo con respecto a su consulta. Esto no crea una relación abogado-cliente.',
    'form.submit': 'Enviar Solicitud de Consulta',
    'form.submitting': 'Enviando...',
    'form.note': 'Nota: Enviar este formulario no crea una relación abogado-cliente. No incluya información confidencial o sensible al tiempo en este formulario.',
    'form.success': '¡Solicitud de consulta enviada exitosamente!',
    'form.success.desc': 'Nos pondremos en contacto con usted dentro de 24 horas.',
    'form.error': 'Error al enviar la solicitud de consulta',
    'form.error.desc': 'Por favor intente nuevamente o llámenos directamente.',
    'form.select.placeholder': 'Seleccione un área de práctica',
    
    // Consultation Additional Fields
    'consult.urgency': '¿Qué tan urgente es su caso?',
    'consult.urgency.placeholder': 'Seleccione nivel de urgencia',
    'consult.urgency.immediate': 'Inmediato (Dentro de 24 horas)',
    'consult.urgency.week': 'Esta Semana',
    'consult.urgency.month': 'Este Mes',
    'consult.urgency.flexible': 'Flexible',
    'consult.language': 'Idioma Preferido para Consulta',
    'consult.language.placeholder': 'Seleccione idioma preferido',
    'consult.appointment.title': 'Agende su Cita',
    'consult.appointment.desc': 'Elija su tipo de cita y fecha preferida',
    'consult.preferredDate': 'Fecha Preferida',
    'consult.selectDate': 'Seleccione una fecha',
    'consult.dateNote': 'Confirmaremos la hora exacta después de revisar su solicitud',
    
    // Booking form
    'booking.title': 'Agende Su Consulta',
    'booking.subtitle': 'Reserve su cita de consulta directamente a través de Google Calendar para confirmación inmediata',
    'booking.step': 'Paso',
    'booking.of': 'de',
    'booking.next': 'Siguiente',
    'booking.previous': 'Anterior',
    'booking.submit': 'Enviar Reserva',
    'booking.selectService': 'Seleccione el Tipo de Servicio',
    'booking.selectServiceDescription': 'Elija el servicio legal para el que necesita consulta',
    'booking.immigration': 'Inmigración',
    'booking.criminalDefense': 'Defensa Criminal',
    'booking.personalInjury': 'Lesiones Personales',
    'booking.familyLaw': 'Derecho Familiar',
    'booking.tax': 'Impuestos',
    'booking.probateEstate': 'Testamentos y Sucesiones',
    'booking.realEstate': 'Bienes Raíces',
    'booking.businessLaw': 'Derecho Empresarial',
    'booking.fullName': 'Nombre Completo',
    'booking.dateOfBirth': 'Fecha de Nacimiento',
    'booking.email': 'Correo Electrónico',
    'booking.phone': 'Número de Teléfono',
    'booking.address': 'Dirección',
    'booking.employerTitle': 'Empleador y Puesto',
    'booking.situation': 'Explique su situación en detalle',
    'booking.situationPlaceholder': 'Por favor describa su situación legal (mínimo 30 caracteres)',
    'booking.appointmentType': 'Tipo de Cita',
    'booking.inPerson': 'En persona',
    'booking.phoneCall': 'Teléfono',
    'booking.video': 'Video',
    'booking.chooseDateTime': 'Elija Fecha y Hora',
    'booking.viewAvailability': 'Ver Horarios Disponibles',
    'booking.calendarDesc': 'Vea nuestro calendario de disponibilidad abajo para ver los horarios libres. Después de confirmar el pago, programaremos su cita según disponibilidad mutua.',
    'booking.calendarNote': 'Las fechas mostradas están en Hora Central (Houston, TX). Su hora exacta de cita será confirmada después del pago.',
    'booking.preferredDate': 'Fecha Preferida de Cita',
    'booking.preferredTime': 'Hora Preferida',
    'booking.referredBy': '¿Cómo se enteró de nosotros?',
    'booking.search': 'Motor de Búsqueda',
    'booking.googleAds': 'Anuncios de Google',
    'booking.facebook': 'Facebook',
    'booking.instagram': 'Instagram',
    'booking.blog': 'Blog',
    'booking.other': 'Otro',
    'booking.referredOther': 'Por favor especifique',
    'booking.consentNotifications': 'Acepto recibir notificaciones por correo electrónico para esta cita',
    'booking.consentTerms': 'Entiendo que esta consulta no es reembolsable y no crea una relación abogado-cliente',
    'booking.required': 'Este campo es obligatorio',
    'booking.minLength': 'Se requieren mínimo {count} caracteres',
    'booking.invalidEmail': 'Correo electrónico inválido',
    'booking.invalidPhone': 'Número de teléfono inválido',
    'booking.yes': 'Sí',
    'booking.no': 'No',
    'booking.paymentTitle': 'Método de Pago',
    'booking.paymentDescription': 'Elija cómo desea pagar su consulta ($150 USD)',
    'booking.stripe': 'Tarjeta de Crédito/Débito (Stripe)',
    'booking.zelle': 'Zelle',
    'booking.checkWire': 'Cheque/Transferencia Bancaria',
    'booking.zelleInstructions': 'Instrucciones de Zelle',
    'booking.zelleEmail': 'Enviar pago a: payment@danielalbertlaw.com',
    'booking.zelleConfirmation': 'Número de Confirmación de Zelle',
    'booking.zelleConfirmationPlaceholder': 'Ingrese su número de confirmación',
    'booking.checkWireInstructions': 'Instrucciones de Cheque/Transferencia',
    'booking.checkWireDetails': 'Por favor contacte nuestra oficina al (832) 538-0833 para detalles de pago.',
    'booking.paymentEvidence': 'Subir Comprobante de Pago (Opcional)',
    'booking.paymentEvidenceDescription': 'Puede subir una captura de pantalla o foto de su confirmación de pago',
    
    // Booking Success Page
    'bookingSuccess.title': '¡Pago Exitoso!',
    'bookingSuccess.subtitle': 'Su consulta ha sido reservada y confirmada',
    'bookingSuccess.bookingNumber': 'Número de Reserva',
    'bookingSuccess.whatsNext': '¿Qué sigue?',
    'bookingSuccess.step1': 'Confirmación por Email',
    'bookingSuccess.step1Desc': 'Recibirá un correo de confirmación con los detalles de su cita en unos minutos.',
    'bookingSuccess.step2': 'Prepare Sus Documentos',
    'bookingSuccess.step2Desc': 'Por favor traiga todos los documentos relevantes a su consulta.',
    'bookingSuccess.step3': 'Llegue a Tiempo',
    'bookingSuccess.step3Desc': 'Por favor llegue 10 minutos antes de su cita programada.',
    'bookingSuccess.reminder': 'Recordatorio Importante',
    'bookingSuccess.reminderText': 'Esta consulta es no reembolsable. La consulta no crea una relación abogado-cliente hasta que se firme un acuerdo de representación.',
    'bookingSuccess.officeLocation': 'Ubicación de la Oficina:',
    'bookingSuccess.contact': 'Contacto:',
    'bookingSuccess.returnHome': 'Volver al Inicio',
    'bookingSuccess.addToCalendar': 'Agregar al Calendario',
  },
  vi: {
    // Header
    'header.call': 'Gọi Cho Chúng Tôi',
    'header.email': 'Gửi Email',
    'header.home': 'Trang Chủ',
    'header.about': 'Về Chúng Tôi',
    'header.practices': 'Lĩnh Vực Hoạt Động',
    'header.contact': 'Liên Hệ',
    'header.consultation': 'Tư Vấn Miễn Phí',
    'header.tools': 'Công Cụ',
    'header.blog': 'Blog',
    
    // Practice Areas
    'practices.immigration': 'Dịch Vụ Di Trú',
    'practices.criminal': 'Bào Chữa Hình Sự',
    'practices.injury': 'Thương Tích Cá Nhân',
    'practices.family': 'Luật Gia Đình',
    'practices.tax': 'Luật Thuế',
    'practices.probate': 'Di Chúc & Kế Hoạch Tài Sản',
    'practices.realestate': 'Luật Bất Động Sản',
    'practices.business': 'Luật Doanh Nghiệp',
    
    // Common CTAs
    'cta.schedule': 'Đặt Lịch Tư Vấn Miễn Phí',
    'cta.contact': 'Liên Hệ Ngay Hôm Nay',
    'cta.learn': 'Tìm Hiểu Thêm',
    'cta.call.en': 'Gọi Tiếng Anh',
    'cta.call.es': 'Gọi Tiếng Tây Ban Nha',
    'cta.call.vi': 'Gọi Tiếng Việt',
    
    // Emergency (removed as per requirements)
    'emergency.title': 'Cần Hỗ Trợ Pháp Lý Ngay?',
    'emergency.desc': 'Liên hệ với chúng tôi trong giờ làm việc hoặc đặt lịch tư vấn:',
    
    // Footer
    'footer.about': 'Về',
    'footer.services': 'Dịch Vụ',
    'footer.resources': 'Tài Nguyên',
    'footer.legal': 'Chính Sách Bảo Mật',
    'footer.terms': 'Điều Khoản Sử Dụng',
    'footer.rights': 'Mọi quyền được bảo lưu',
    'footer.disclaimer': 'Thông tin trên trang web này chỉ dành cho mục đích thông tin chung. Không có gì trên trang này nên được coi là lời khuyên pháp lý cho bất kỳ trường hợp hoặc tình huống cá nhân nào.',
    'footer.quicklinks': 'Liên Kết Nhanh',
    'footer.contact': 'Liên Hệ',
    'footer.description': 'Đại diện pháp lý chuyên nghiệp trong di trú, bào chữa hình sự, thương tích cá nhân và hơn thế nữa. Phục vụ Houston với sự tận tâm và chính trực.',
    'footer.areas': 'Khu Vực Chúng Tôi Phục Vụ',
    'footer.areas.serving': 'Luật Sư Di Trú Phục Vụ:',
    
    // Practice Area Descriptions
    'practices.immigration.desc': 'Dịch vụ pháp lý di trú toàn diện',
    'practices.criminal.desc': 'Đại diện bào chữa hình sự chuyên nghiệp',
    'practices.injury.desc': 'Chiến đấu cho yêu cầu bồi thường của bạn',
    'practices.family.desc': 'Hướng dẫn luật gia đình đầy cảm thông',
    'practices.tax.desc': 'Kiện tụng và giải quyết thuế',
    'practices.probate.desc': 'Bảo vệ di sản của bạn',
    'practices.realestate.desc': 'Giao dịch và tranh chấp bất động sản',
    'practices.business.desc': 'Thành lập và bảo vệ doanh nghiệp',
    
    // Blog Page
    'blog.title': 'Blog Pháp Lý',
    'blog.subtitle': 'Thông tin pháp lý chuyên môn, cập nhật và hướng dẫn từ Văn Phòng Luật Daniel Albert',
    'blog.all': 'Tất Cả',
    'blog.read': 'Đọc Thêm',
    'blog.subscribe': 'Cập Nhật Thông Tin',
    'blog.subscribe.desc': 'Đăng ký nhận bản tin của chúng tôi để nhận các cập nhật pháp lý mới nhất, tin tức di trú và tài nguyên hữu ích.',
    'blog.email': 'Địa chỉ email của bạn',
    'blog.subscribe.btn': 'Đăng Ký',
    
    // Homepage
    'home.hero.title': 'Luật Sư Di Trú Hàng Đầu tại Houston, Texas',
    'home.hero.subtitle': 'Dịch vụ di trú chuyên nghiệp bao gồm tị nạn, nhập tịch, visa, phòng thủ trục xuất. Cũng cung cấp Bào Chữa Hình Sự, Thương Tích Cá Nhân, Luật Gia Đình & nhiều hơn. Dịch vụ ba ngôn ngữ (Anh/Tây Ban Nha/Việt).',
    'home.hero.consultation': 'Đặt Lịch Tư Vấn',
    'home.hero.call': 'Gọi',
    'home.areas.title': 'Lĩnh Vực Hoạt Động Của Chúng Tôi',
    'home.areas.subtitle': 'Dịch vụ pháp lý toàn diện trong nhiều lĩnh vực luật pháp',
    'home.areas.viewall': 'Xem Tất Cả Lĩnh Vực Hoạt Động',
    'home.why.title': 'Tại Sao Chọn Văn Phòng Luật Daniel Albert?',
    'home.why.subtitle': 'Đại diện pháp lý tận tâm với thành tích đã được chứng minh',
    'home.why.team': 'Đội Ngũ Luật Sư Có Kinh Nghiệm',
    'home.why.team.desc': 'Nhiều năm đại diện thành công trong nhiều lĩnh vực thực hành tại Houston và xa hơn.',
    'home.why.bilingual': 'Dịch Vụ Ba Ngôn Ngữ',
    'home.why.bilingual.desc': 'Thành thạo tiếng Anh, tiếng Tây Ban Nha và tiếng Việt, đảm bảo giao tiếp rõ ràng trong suốt trường hợp của bạn.',
    'home.why.available': 'Dịch Vụ Nhanh Chóng',
    'home.why.available.desc': 'Phản hồi nhanh chóng đối với nhu cầu pháp lý của bạn trong giờ làm việc với các tùy chọn lịch trình linh hoạt.',
    'home.why.results': 'Kết Quả Đã Được Chứng Minh',
    'home.why.results.desc': 'Thành tích các kết quả thành công trong các vụ án phức tạp và thách thức.',
    'home.process.title': 'Quy Trình Của Chúng Tôi',
    'home.process.subtitle': 'Cách tiếp cận đơn giản, hiệu quả cho các vấn đề pháp lý của bạn',
    'home.process.step1': 'Tư Vấn Miễn Phí',
    'home.process.step1.desc': 'Thảo luận về trường hợp của bạn với các luật sư có kinh nghiệm của chúng tôi miễn phí.',
    'home.process.step2': 'Chiến Lược Vụ Án',
    'home.process.step2.desc': 'Chúng tôi phát triển chiến lược pháp lý tùy chỉnh phù hợp với tình huống của bạn.',
    'home.process.step3': 'Đại Diện',
    'home.process.step3.desc': 'Chúng tôi xử lý tất cả các hồ sơ, giao tiếp và xuất hiện tại tòa án.',
    'home.process.step4': 'Giải Quyết',
    'home.process.step4.desc': 'Chúng tôi chiến đấu cho kết quả tốt nhất có thể trong trường hợp của bạn.',
    'home.testimonials.title': 'Lời Chứng Thực Của Khách Hàng',
    'home.testimonials.subtitle': 'Xem những gì khách hàng của chúng tôi nói về dịch vụ của chúng tôi',
    
    // Testimonials Section
    'testimonials.title': 'Được Tin Tưởng Bởi Gia Đình và Doanh Nghiệp Trên Khắp Houston',
    'testimonials.subtitle': 'Nghe những gì khách hàng của chúng tôi nói về trải nghiệm của họ với Văn Phòng Luật Daniel Albert',
    'testimonials.viewMore': 'Xem Tất Cả Đánh Giá',
    
    // Video Testimonials Section
    'home.videoTestimonials.title': 'Lời Chứng Thực Video Của Khách Hàng',
    'home.videoTestimonials.subtitle': 'Câu chuyện thực từ khách hàng thực - nghe trực tiếp từ những người chúng tôi đã giúp đỡ',
    
    // Chatbot
    'chatbot.title': 'Trợ Lý Pháp Lý',
    'chatbot.subtitle': 'Hỏi tôi về dịch vụ của chúng tôi',
    'chatbot.placeholder': 'Nhập câu hỏi của bạn...',
    'chatbot.schedule': 'Đặt Lịch Tư Vấn Miễn Phí',
    
    'home.cta.ready': 'Sẵn Sàng Thảo Luận Về Trường Hợp Của Bạn?',
    'home.cta.ready.desc': 'Liên hệ với Văn Phòng Luật Daniel Albert ngay hôm nay để được tư vấn miễn phí. Các luật sư có kinh nghiệm của chúng tôi sẵn sàng chiến đấu cho quyền của bạn.',
    
    // Practice Areas Page
    'pa.title': 'Lĩnh Vực Hoạt Động Của Chúng Tôi',
    'pa.subtitle': 'Dịch vụ pháp lý toàn diện trong nhiều lĩnh vực luật pháp. Dù nhu cầu pháp lý của bạn là gì, chúng tôi ở đây để giúp đỡ.',
    'pa.why.title': 'Tại Sao Chọn Văn Phòng Luật Daniel Albert?',
    'pa.why.subtitle': 'Bất kể thách thức pháp lý nào bạn đang đối mặt, đội ngũ có kinh nghiệm của chúng tôi sẵn sàng cung cấp đại diện mà bạn xứng đáng.',
    'pa.why.expertise': 'Chuyên Môn Đa Lĩnh Vực',
    'pa.why.expertise.desc': 'Tám lĩnh vực thực hành dưới một mái nhà có nghĩa là hỗ trợ pháp lý toàn diện cho tất cả nhu cầu của bạn.',
    'pa.why.trilingual': 'Dịch Vụ Ba Ngôn Ngữ',
    'pa.why.trilingual.desc': 'Dịch vụ pháp lý đầy đủ bằng tiếng Anh, tiếng Tây Ban Nha và tiếng Việt, đảm bảo giao tiếp rõ ràng.',
    'pa.why.response': 'Dịch Vụ Nhanh',
    'pa.why.response.desc': 'Phản hồi nhanh trong giờ làm việc với lịch hẹn tư vấn linh hoạt để đáp ứng nhu cầu của bạn.',
    'pa.cta.title': 'Không Chắc Bạn Cần Dịch Vụ Nào?',
    'pa.cta.desc': 'Liên hệ với chúng tôi để được tư vấn miễn phí. Chúng tôi sẽ thảo luận về tình huống của bạn và hướng dẫn bạn đến giải pháp pháp lý đúng đắn.',
    'pa.keyservices': 'Dịch Vụ Chính:',
    
    // CTA Section
    'cta.ready': 'Sẵn Sàng Bắt Đầu?',
    'cta.ready.desc': 'Liên hệ với chúng tôi ngay hôm nay để được tư vấn. Chúng tôi ở đây để giúp bạn điều hướng các thách thức pháp lý của bạn.',
    'cta.emergency.title': 'Cần Hỗ Trợ Pháp Lý?',
    'cta.emergency.desc': 'Liên hệ với chúng tôi trong giờ làm việc để được chú ý ngay lập tức đến vấn đề pháp lý của bạn.',
    'cta.callnow': 'Gọi Ngay',
    'cta.english': 'Tiếng Anh',
    'cta.spanish': 'Tiếng Tây Ban Nha',
    'cta.vietnamese': 'Tiếng Việt',
    'cta.disclaimer': 'Tư vấn miễn phí khi bạn sử dụng dịch vụ của chúng tôi bằng cách nhận khoản tín dụng $150 cho phí pháp lý của bạn.',
    'cta.consultation.button': 'Đặt Lịch Tư Vấn',
    
    // Consultation Form
    'form.title': 'Yêu Cầu Tư Vấn',
    'form.gcal.button': 'Đặt Lịch trên Google Calendar',
    'form.gcal.note': 'Tình trạng có thể thay đổi so với hệ thống nội bộ của chúng tôi',
    'form.gcal.opens': 'Mở trong cửa sổ mới',
    'consult.calendar.desc': 'Đặt lịch hẹn tư vấn của bạn trực tiếp qua Google Calendar để xác nhận ngay lập tức.',
    'form.name': 'Tên Đầy Đủ',
    'form.email': 'Email',
    'form.phone': 'Số Điện Thoại',
    'form.area': 'Lĩnh Vực Hoạt Động',
    'form.message': 'Tin Nhắn',
    'form.message.placeholder': 'Vui lòng mô tả vấn đề pháp lý của bạn...',
    'form.message.desc': 'Mô tả ngắn gọn về vấn đề pháp lý của bạn (10-1000 ký tự)',
    'form.consent': 'Tôi đồng ý với các điều khoản và điều kiện',
    'form.consent.desc': 'Bằng cách gửi biểu mẫu này, bạn đồng ý rằng Văn Phòng Luật Daniel Albert có thể liên hệ với bạn về yêu cầu của bạn. Điều này không tạo ra mối quan hệ luật sư-khách hàng.',
    'form.submit': 'Gửi Yêu Cầu Tư Vấn',
    'form.submitting': 'Đang Gửi...',
    'form.note': 'Lưu ý: Gửi biểu mẫu này không tạo ra mối quan hệ luật sư-khách hàng. Không bao gồm thông tin bí mật hoặc nhạy cảm về thời gian trong biểu mẫu này.',
    'form.success': 'Đã gửi yêu cầu tư vấn thành công!',
    'form.success.desc': 'Chúng tôi sẽ liên hệ với bạn trong vòng 24 giờ.',
    'form.error': 'Không gửi được yêu cầu tư vấn',
    'form.error.desc': 'Vui lòng thử lại hoặc gọi trực tiếp cho chúng tôi.',
    'form.select.placeholder': 'Chọn một lĩnh vực hoạt động',
    
    // Consultation Additional Fields
    'consult.urgency': 'Mức độ khẩn cấp của vụ việc?',
    'consult.urgency.placeholder': 'Chọn mức độ khẩn cấp',
    'consult.urgency.immediate': 'Ngay lập tức (Trong 24 giờ)',
    'consult.urgency.week': 'Tuần Này',
    'consult.urgency.month': 'Tháng Này',
    'consult.urgency.flexible': 'Linh Hoạt',
    'consult.language': 'Ngôn Ngữ Ưu Tiên Cho Tư Vấn',
    'consult.language.placeholder': 'Chọn ngôn ngữ ưu tiên',
    'consult.appointment.title': 'Đặt Lịch Hẹn Của Bạn',
    'consult.appointment.desc': 'Chọn loại cuộc hẹn và ngày ưu tiên',
    'consult.preferredDate': 'Ngày Ưu Tiên',
    'consult.selectDate': 'Chọn một ngày',
    'consult.dateNote': 'Chúng tôi sẽ xác nhận thời gian chính xác sau khi xem xét yêu cầu của bạn',
    
    // Booking form
    'booking.title': 'Đặt Lịch Tư Vấn Của Bạn',
    'booking.subtitle': 'Đặt lịch hẹn tư vấn của bạn trực tiếp qua Google Calendar để xác nhận ngay lập tức',
    'booking.step': 'Bước',
    'booking.of': 'của',
    'booking.next': 'Tiếp theo',
    'booking.previous': 'Quay lại',
    'booking.submit': 'Gửi Đặt Chỗ',
    'booking.selectService': 'Chọn Loại Dịch Vụ',
    'booking.selectServiceDescription': 'Chọn dịch vụ pháp lý bạn cần tư vấn',
    'booking.immigration': 'Di Trú',
    'booking.criminalDefense': 'Bào Chữa Hình Sự',
    'booking.personalInjury': 'Thương Tích Cá Nhân',
    'booking.familyLaw': 'Luật Gia Đình',
    'booking.tax': 'Thuế',
    'booking.probateEstate': 'Di Chúc & Lập Kế Hoạch Bất Động Sản',
    'booking.realEstate': 'Bất Động Sản',
    'booking.businessLaw': 'Luật Doanh Nghiệp',
    'booking.fullName': 'Họ và Tên',
    'booking.dateOfBirth': 'Ngày Sinh',
    'booking.email': 'Email',
    'booking.phone': 'Số Điện Thoại',
    'booking.address': 'Địa Chỉ',
    'booking.employerTitle': 'Chủ Lao Động & Chức Danh',
    'booking.situation': 'Giải thích chi tiết tình huống của bạn',
    'booking.situationPlaceholder': 'Vui lòng mô tả tình huống pháp lý của bạn (tối thiểu 30 ký tự)',
    'booking.appointmentType': 'Loại Cuộc Hẹn',
    'booking.inPerson': 'Trực tiếp',
    'booking.phoneCall': 'Điện thoại',
    'booking.video': 'Video',
    'booking.chooseDateTime': 'Chọn Ngày & Giờ',
    'booking.viewAvailability': 'Xem Giờ Có Sẵn',
    'booking.calendarDesc': 'Kiểm tra lịch khả dụng của chúng tôi bên dưới để xem các khoảng thời gian trống. Sau khi xác nhận thanh toán, chúng tôi sẽ lên lịch hẹn của bạn dựa trên khả dụng chung.',
    'booking.calendarNote': 'Ngày hiển thị theo Giờ Miền Trung (Houston, TX). Giờ hẹn chính xác sẽ được xác nhận sau khi thanh toán.',
    'booking.preferredDate': 'Ngày Hẹn Ưu Tiên',
    'booking.preferredTime': 'Giờ Ưu Tiên',
    'booking.referredBy': 'Bạn biết đến chúng tôi qua đâu?',
    'booking.search': 'Công Cụ Tìm Kiếm',
    'booking.googleAds': 'Quảng Cáo Google',
    'booking.facebook': 'Facebook',
    'booking.instagram': 'Instagram',
    'booking.blog': 'Blog',
    'booking.other': 'Khác',
    'booking.referredOther': 'Vui lòng ghi rõ',
    'booking.consentNotifications': 'Tôi đồng ý nhận thông báo email cho cuộc hẹn này',
    'booking.consentTerms': 'Tôi hiểu rằng tư vấn này không hoàn tiền và không tạo ra mối quan hệ luật sư-khách hàng',
    'booking.required': 'Trường này là bắt buộc',
    'booking.minLength': 'Yêu cầu tối thiểu {count} ký tự',
    'booking.invalidEmail': 'Địa chỉ email không hợp lệ',
    'booking.invalidPhone': 'Số điện thoại không hợp lệ',
    'booking.yes': 'Có',
    'booking.no': 'Không',
    'booking.paymentTitle': 'Phương Thức Thanh Toán',
    'booking.paymentDescription': 'Chọn cách bạn muốn thanh toán cho tư vấn của mình ($150 USD)',
    'booking.stripe': 'Thẻ Tín Dụng/Ghi Nợ (Stripe)',
    'booking.zelle': 'Zelle',
    'booking.checkWire': 'Séc/Chuyển Khoản Ngân Hàng',
    'booking.zelleInstructions': 'Hướng Dẫn Zelle',
    'booking.zelleEmail': 'Gửi thanh toán đến: payment@danielalbertlaw.com',
    'booking.zelleConfirmation': 'Số Xác Nhận Zelle',
    'booking.zelleConfirmationPlaceholder': 'Nhập số xác nhận của bạn',
    'booking.checkWireInstructions': 'Hướng Dẫn Séc/Chuyển Khoản',
    'booking.checkWireDetails': 'Vui lòng liên hệ văn phòng của chúng tôi tại (832) 538-0833 để biết chi tiết thanh toán.',
    'booking.paymentEvidence': 'Tải Lên Bằng Chứng Thanh Toán (Tùy Chọn)',
    'booking.paymentEvidenceDescription': 'Bạn có thể tải lên ảnh chụp màn hình hoặc ảnh xác nhận thanh toán của bạn',
    
    // Booking Success Page
    'bookingSuccess.title': 'Thanh Toán Thành Công!',
    'bookingSuccess.subtitle': 'Lịch tư vấn của bạn đã được đặt và xác nhận',
    'bookingSuccess.bookingNumber': 'Số Đặt Chỗ',
    'bookingSuccess.whatsNext': 'Bước Tiếp Theo?',
    'bookingSuccess.step1': 'Xác Nhận Qua Email',
    'bookingSuccess.step1Desc': 'Bạn sẽ nhận được email xác nhận với chi tiết cuộc hẹn trong vài phút.',
    'bookingSuccess.step2': 'Chuẩn Bị Tài Liệu',
    'bookingSuccess.step2Desc': 'Vui lòng mang theo tất cả các tài liệu liên quan đến buổi tư vấn.',
    'bookingSuccess.step3': 'Đến Đúng Giờ',
    'bookingSuccess.step3Desc': 'Vui lòng đến trước 10 phút so với giờ hẹn đã định.',
    'bookingSuccess.reminder': 'Lưu Ý Quan Trọng',
    'bookingSuccess.reminderText': 'Buổi tư vấn này không hoàn tiền. Buổi tư vấn không tạo ra mối quan hệ luật sư-khách hàng cho đến khi ký hợp đồng đại diện.',
    'bookingSuccess.officeLocation': 'Địa Chỉ Văn Phòng:',
    'bookingSuccess.contact': 'Liên Hệ:',
    'bookingSuccess.returnHome': 'Quay Về Trang Chủ',
    'bookingSuccess.addToCalendar': 'Thêm Vào Lịch',
  },
};

export type Language = 'en' | 'es' | 'vi';
export type TranslationKey = keyof typeof translations.en;
